module.exports = __webpack_public_path__ + "img/spring_trip-20160416-7.79fbb155.jpg";